import { render, staticRenderFns } from "./ProposalProductSelectCard.vue?vue&type=template&id=1dffdd1e&scoped=true&"
import script from "./ProposalProductSelectCard.vue?vue&type=script&lang=js&"
export * from "./ProposalProductSelectCard.vue?vue&type=script&lang=js&"
import style0 from "./ProposalProductSelectCard.vue?vue&type=style&index=0&id=1dffdd1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dffdd1e",
  null
  
)

export default component.exports